import React from "react"

import {
  TitleSection,
  PaginatedListWithSearch,
  ListItemDeliveryNote
} from "~/components/"
import {useTranslation} from "react-i18next"

const DeliveryNotesView = () => {
  const {t} = useTranslation()
  return (
    <React.Fragment>
      <TitleSection>
        <h3>{t("deliveryNotes.title")}</h3>
      </TitleSection>

      <PaginatedListWithSearch
        apiPath="/delivery_notes"
        itemRenderer={ListItemDeliveryNote}
      >
        <p>{t("deliveryNotes.nothing")}</p>
      </PaginatedListWithSearch>
    </React.Fragment>
  )
}

export default DeliveryNotesView



// WEBPACK FOOTER //
// ./src/views/DeliveryNotesView.js